import React from 'react'
import CampSeasonal from '../camp-seasonal/camp-seasonal.js'
import SectionBlock from '../section-block'
import { filterArrayByType } from '../../utility.js'

import * as styles from './index.module.css'
import { linkResolver } from '../../linkResolver.js'

export default ({
  title,
  description,
  body,
  sliceData,
  inset = true,
  classList,
  ...args
}) => {
  let data = sliceData || filterArrayByType(body, 'column')[0]
  // console.log('column', data)

  if (!data || data.length === 0) {
    return null
  }

  const sectionTitle = data?.primary
    ? data?.primary?.column_section_title
    : null

  return (
    <SectionBlock {...args} classList={classList}>
      <div className="container">
        {sectionTitle && <h2 className={styles.title}>{sectionTitle}</h2>}
        <div className="row">
          <div className={inset ? 'col-md-10 offset-md-1' : 'col-md-12'}>
            <div className="row v-20-s">
              {data.items.map((d, i) => {
                /* console.log('column', `${i}.`, d) */
                return (
                  <div className="col-md-4" key={i}>
                    <CampSeasonal
                      color={d.color}
                      image={d.column_image}
                      title={d.column_title.text}
                      description={d.column_text.richText}
                      btnText={d.cta_label || d.column_cta_label}
                      link={linkResolver(d.cta_link || d.column_cta)}
                      price={d.plu}
                      priceQualifier={d.plu_2}
                      price2={d.plu_2_description}
                      priceQualifier2={d.plu_description}
                      />
                  </div>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    </SectionBlock>
  )
}
